import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["questionKey"];
import ProductInfoContainer from 'pricing-pages-lib/js/components/ProductInfoContainer.tsx';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import ProductPageSubtitle from '../components/common/ProductPageSubtitle';
import ProductPageTitle from '../components/common/ProductPageTitle';
import Faq from '../components/faqs/Faq';
import FooterMicrocopy from '../components/faqs/FooterMicrocopy';
import Question from '../components/faqs/Question';
import HeaderLayout from '../components/layout/HeaderLayout';
import { FaqsConfig } from '../constants/faqs/FaqsConfig';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useIsMobile } from 'pricing-pages-lib/js/context/IsMobileContext.tsx';
import { PPUIPageHeader } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import CaseStudies from 'pricing-pages-ui/components/case-studies/CaseStudies';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import BannerSection from '../components/banners/BannerSection';
import PaymentsProcessorsWrapper from '../components/commerce-hub/PaymentsProcessorsWrapper';
import BringCommerceCtaCard from '../components/commerce/BringCommerceCtaCard';
import { CommerceFeaturesSection } from '../components/commerce/CommerceFeaturesSection';
import FailedLoadBanner from '../components/common/loading/FailedLoadBanner';
import FallbackErrorBanner from '../components/common/loading/FallbackErrorBanner';
import CompanyProof from '../components/company-proof/CompanyProof';
import MobileWrapper from '../components/mobile/containers/MobileWrapper';
import { NavItemEnum } from '../constants/routing/NavItems';
import { ENTERPRISE, STARTER } from '../constants/routing/Tabs';
import { SCREENS } from '../constants/tracking/Screens';
import { useAppSelector } from '../reducers';
import { hasPricingAndPurchasingFailedSelector } from '../selectors/LoadingStateSelectors';
import { trackPageView } from '../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CommercePage = () => {
  const pageName = NavItemEnum.COMMERCE;
  useDocumentTitle(pageName);
  const isMobile = useIsMobile();
  const navMarkerName = `${pageName.toUpperCase()}_PAGE`;
  const hasPricingAndPurchasingFailed = useAppSelector(hasPricingAndPurchasingFailedSelector);
  useEffect(() => {
    trackPageView({
      screen: pageName
    });
  }, [pageName]);
  const PageWrapper = ({
    children
  }) => {
    if (isMobile) {
      return /*#__PURE__*/_jsx(MobileWrapper, {
        navMarkerName: navMarkerName,
        navItem: NavItemEnum.COMMERCE,
        children: children
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      "data-selenium-id": "page-success",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: navMarkerName
      }), /*#__PURE__*/_jsx(HeaderLayout, {
        selectedNavItem: pageName,
        children: /*#__PURE__*/_jsx(ProductInfoContainer, {
          children: children
        })
      })]
    });
  };
  return /*#__PURE__*/_jsxs(PageWrapper, {
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: SCREENS.COMMERCE
    }), /*#__PURE__*/_jsx(FailedLoadBanner, {
      hasFailed: hasPricingAndPurchasingFailed
    }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsxs(PPUIPageHeader, {
      children: [/*#__PURE__*/_jsx(ProductPageTitle, {
        productLine: COMMERCE
      }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
        productLine: COMMERCE
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(BringCommerceCtaCard, {})
    }), /*#__PURE__*/_jsx(PaymentsProcessorsWrapper, {}), /*#__PURE__*/_jsx(CommerceFeaturesSection, {}), /*#__PURE__*/_jsx(CompanyProof, {
      tab: ENTERPRISE,
      screen: SCREENS.COMMERCE
    }), /*#__PURE__*/_jsx(CaseStudies, {
      productLine: COMMERCE,
      tab: STARTER
    }), /*#__PURE__*/_jsxs(Faq, {
      children: [FaqsConfig[pageName.toLowerCase()].map(_ref => {
        let {
            questionKey
          } = _ref,
          passthroughOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
        return /*#__PURE__*/_jsx(Question, Object.assign({
          questionKey: questionKey
        }, passthroughOptions), questionKey);
      }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
    })]
  });
};
export default CommercePage;